/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown> }} User_Toggle_RoleInputs */



/**
* | output |
* | --- |
* | "Toggle {role}" |
*
* @param {User_Toggle_RoleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_toggle_role = /** @type {((inputs: User_Toggle_RoleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Toggle_RoleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Basculer ${i?.role}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Activar/desactivar ${i?.role}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Alternar ${i?.role}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Attiva/disattiva ${i?.role}`)
	return /** @type {LocalizedString} */ (`Toggle ${i?.role}`)
});